import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "../data/catalog";

export const ProductCategories = () => {
  return (
    <section data-testid="product-categories" className="bg-white py-20 md:py-28">
      <div className="leduro-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="leduro-eyebrow">— Catalogue</span>
            <h2 className="mt-3 font-heading font-black tracking-tighter text-leduro-navy text-3xl md:text-5xl text-balance">
              Leduro Product Categories
            </h2>
            <p className="mt-3 text-leduro-muted text-base md:text-lg max-w-xl">
              Seven product families. One technical standard. Choose a category to view in-stock SKUs and datasheets.
            </p>
          </div>
          <Link to="/catalogue" data-testid="categories-view-all" className="leduro-btn-ghost self-start md:self-auto">
            View All
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-px bg-leduro-border border border-leduro-border">
          {CATEGORIES.map((c, i) => (
            <Link
              key={c.slug}
              to={`/catalogue/${c.slug}`}
              data-testid={`category-card-${c.slug}`}
              className="group relative bg-white p-6 lg:p-7 transition-colors hover:bg-leduro-surface"
            >
              <div className="flex items-start justify-between">
                <span className="font-mono text-xs text-leduro-muted">
                  0{i + 1}
                </span>
                <ArrowUpRight className="h-5 w-5 text-leduro-navy/30 group-hover:text-leduro-orange group-hover:rotate-12 transition-all" />
              </div>

              <div className="mt-4 aspect-square bg-leduro-surface border border-leduro-border overflow-hidden">
                <img
                  src={c.image}
                  alt={c.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <h3 className="mt-5 font-heading font-bold text-leduro-navy text-lg group-hover:text-leduro-orange transition-colors">
                {c.name}
              </h3>
              <p className="mt-2 text-sm text-leduro-muted line-clamp-2 leading-relaxed">
                {c.description}
              </p>

              <div className="mt-5 inline-flex items-center gap-2 text-[11px] tracking-[0.24em] uppercase font-bold text-leduro-navy">
                Browse {c.short}
                <span className="h-px w-6 bg-leduro-orange transition-all group-hover:w-12" />
              </div>
            </Link>
          ))}

          {/* Filler / CTA tile to align grid */}
          <Link
            to="/catalogue"
            data-testid="category-card-all"
            className="group relative bg-leduro-navy text-white p-6 lg:p-7 flex flex-col justify-between"
          >
            <div>
              <span className="leduro-eyebrow text-leduro-orange">— Discover</span>
              <h3 className="mt-3 font-heading font-black tracking-tighter text-2xl leading-tight">
                All product families in one place.
              </h3>
            </div>
            <div className="flex items-center justify-between mt-6">
              <span className="text-xs uppercase tracking-[0.24em] font-bold text-white">
                Open Catalogue
              </span>
              <ArrowUpRight className="h-6 w-6 text-leduro-orange group-hover:rotate-45 transition-transform" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
